import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.config.productionTip = false;
// Vue.prototype.$api_url = "https://zjzxadmin.jc881.com/api/"; //测试环境
// Vue.prototype.$api_imageUrl = "https://zjzxadmin.jc881.com/"; //测试环境

Vue.prototype.$api_url = "http://zjqyadmin.ynbzde.com/api/"; //正式环境
Vue.prototype.$api_imageUrl = "http://zjqyadmin.ynbzde.com/"; //正式环境

Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
